<template>
  <div class="text-xs-center" style="display:inline-block">
    <v-menu
        :nudge-width="200"
        class="answerListMenu"
        abolute
        left
        bottom
        nudge-top="-20"
        offset-x
        :close-on-content-click="true"
    >
                    <svg
                        slot="activator" style="width:14px;height:14px;margin-left:4px;margin-top:4px;" id="derButton">
                        <template>
                            <answer-info-icon/>
                        </template>
                    </svg>
                    <v-card elevated>
                        <template>
                            <v-container  class="answerList">
                                <v-layout row  class="answerListRow answerListTitle" >

                                    <v-flex xs12>
                                        {{ text('api.summary.communication.allAvailableAnswers') }}
                                    </v-flex>

                                </v-layout>

                                <v-layout row  v-for="(starqAns) in questionList" :key="starqAns.id"
                                class="answerListRow"
                                v-bind:class="[starqAns.isSelected ? 'activeClass' : '']"
                                >

                                <v-flex xs10>
                                    {{starqAns.answerText}}
                                </v-flex>
                                <v-flex xs2>
                                    <done-icon  v-if="starqAns.isSelected" width="24px" height="24px" style="float:right;"/>
                                </v-flex>

                                </v-layout>
                            </v-container>
                        </template>
                    </v-card>
                </v-menu>
  </div>
</template>

<script>
import SvgButton from "./SvgButton";


import {mapGetters} from "vuex";
import AnswerInfoIcon from "../../../common/components/svg/shared/answerInfoIcon";
import DoneIcon from "../../../common/components/svg/shared/DoneIcon";
export default {
    name: "AnswerInfoPopup",
    components: {
        SvgButton,
        AnswerInfoIcon,
        DoneIcon},
    props: {
     questionList : Array
  },

    computed: {
        ...mapGetters({
        }),


    },
    data() {
      return {
        showNavbar: true,
        lastScrollPosition: 0
      }
    },
    methods :{
        onScroll () {
    // Get the current scroll position
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop    // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
    if (currentScrollPosition < 0) {
      return
    }    // Here we determine whether we need to show or hide the navbar
    this.showNavbar = currentScrollPosition < this.lastScrollPosition    // Set the current scroll position as the last scroll position
    this.lastScrollPosition = currentScrollPosition
  }
    },

    mounted() {
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    }
}

</script>

<style scoped lang="scss">


 .answerListTitle{
    font-weight:600;
    color:var(--secondary-color);
 }

 .answerListRow{
    padding:8px 16px;
 }

 .activeClass{
    background-color:#EFEFEF;
    color:#a43a45;
    font-weight: 500;
 }

 div.container.answerList {
    padding:0px;
    margin:0px;
 }
    .settings {
        font-weight: $font-size-medium;

    }


</style>



// WEBPACK FOOTER //
// src/common/components/shared/AnswerInfoPopup.vue